var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.227539 7.50195V0.00195312H7.72754V7.50195H0.227539ZM2.72754 2.50195V5.00195H5.22754V2.50195H2.72754ZM10.2275 0.00195312H17.7275V7.50195H10.2275V0.00195312ZM15.2275 5.00195V2.50195H12.7275V5.00195H15.2275ZM0.227539 17.502V10.002H7.72754V17.502H0.227539ZM2.72754 12.502V15.002H5.22754V12.502H2.72754ZM16.4775 10.002H17.7275V15.002H13.9775V13.752H12.7275V17.502H10.2275V10.002H13.9775V11.252H16.4775V10.002ZM16.4775 16.252H17.7275V17.502H16.4775V16.252ZM13.9775 16.252H15.2275V17.502H13.9775V16.252Z",
    fill: "#F0823E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr-icon.f7e0aabe3a736dc6254c74356c8f1125.svg";
export { ForwardRef as ReactComponent };